import React, { memo } from 'react';
import TabPanel from '@mui/lab/TabPanel';
import AgGrid from 'screens/components/advanced/AgGrid';
import BranchSummary from './BranchSummary';

const TabGrid = memo(({ value, rows, columns, branchSummary }) => {
    return(
        <TabPanel value={value}>
            {branchSummary && <BranchSummary rows={branchSummary} />}
            <AgGrid columns={columns} rows={rows} showFooter />
        </TabPanel>
    )
});

export default TabGrid;